import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InfoIcon from '@material-ui/icons/Info';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import FiliadoRegisterInfo from './components/FiliadoRegisterInfo';
import Box from '@material-ui/core/Box';
import FiliadoToolbar from './components/FiliadoRegisterToolbar';
import AppBar from '@material-ui/core/AppBar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import FiliadoRegisterContacts from './components/FiliadoRegisterContacts/FiliadoRegisterContacts';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import { isAuthenticated } from '../../helpers/authenticate';
import { MessageValues } from '../../values/MessageValues';
import { ValidatorForm } from 'react-material-ui-form-validator';
import FiliadoRegisterVisitas from './components/FiliadoRegisterVisitas/FiliadoRegisterVisitas';
import Grid from '@material-ui/core/Grid';
import FiliadoRegisterEstatisticas from './components/FiliadoRegisterEstatisticas';
import BarChartIcon from '@material-ui/icons/BarChart';
import {
  dadosEstatisticasPessoaisFiliado,
  dadosEstatisticasTrapFiliado,
  dadosVitrineEstatisticaFiliado,
  geetFiliadoPorIdFiliado
} from '../../services/FiliadoService';
import { Values } from '../../values/Values';
import FiliadoRegisterObservacoes from './components/FiliadoRegisterObservacoes';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import { apagarImagem, uploadImagem } from '../../services/ImagemService';
import Fab from '@material-ui/core/Fab';
import PrintIcon from '@material-ui/icons/Print';
import DialogImpressaoVisitas from '../../components/DialogImpressaoVisitas/DialogImpressaoVisitas';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: 10,
    marginLeft: 10,
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderTopRightRadius: 35,
    borderTopLeftRadius: 35
  },
  toolbar: {
    marginRight: 10,
    marginLeft: 10,
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function FiliadoRegister({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  let [filiado, setFiliado] = useState(history.location.state.filiado);
  let [edicao, setEdicao] = useState(history.location.state.edicao);
  const [refreshState, setRefreshState] = useState(new Date());
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [filiacaoStatus, setFiliacaoStatus] = useState({
    result: []
  });
  const [gruposSanguineos, setGruposSanguineos] = useState({
    result: []
  });
  const [dadosVitrineEstatistica, setDadosVitrineEstatistica] = useState({
    valorTotalGasto: 0,
    totalDisparosTrap: 0
  });
  const [dadosDetalhadosEstatisticasPessoas, setDadosDetalhadosEstatisticasPessoais] = useState({
    totaisPorModalidade: [],
    quantidadeTotalModalidades: [],
    totaisPorInsumo: [],
    quantidadeTotalInsumos: [],
    totaisPorvisita: []
  });
  const [dadosDetalhadosEstatisticasTrap, setDadosDetalhadosEstatisticasTrap] = useState({
    rendimentoTotal: {},
    rendimentoPorVisita: []
  });
  const [abrirDialogImpressaoVisitas, setAbrirDialogImpressaoVisitas] = useState(false);


  const [value, setValue] = React.useState(0);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    loadVisitasFiliados();
    carregarGruposSanguines();
    carregarFiliacaoStatus();
    obterDadosVitrineEstatisticaFiliado();
    obterDadosEstatisticasPessoais();
    obterDadosEstatisticasTrap();
  }, []);

  async function loadVisitasFiliados() {
    if(edicao){
      try {
        setLoading(true);
        const dados = await api.get(`visita-filiados/filiado/${filiado.idFiliado}`);
        if (dados.data.isSuccess) {
          for (let i = 0, size = dados.data.result.length; i < size; i++) {
            dados.data.result[i].on_mouse_over = false;
          }
          filiado.visitas = dados.data.result;
          setFiliado(filiado);
          setLoading(false);
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Não foi possível obter visitas do filiado.');
          setShowMessageSnack(true);
        }
      } catch (e) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Ocorreu um erro ao obter visitas dos filiados. Contate o suporte. ERROR: ' + e.toString());
        setShowMessageSnack(true);
      }
    }

  }

  async function carregarGruposSanguines() {
    try{
      setLoading(true);
      const params = {
        limit: 100,
      };
      const dados = await api.get('grupo-sanguineo/', {params: params});
      setLoading(false);
      if(dados.data.isSuccess){
        if(dados.data.result.length !== 0){
          setGruposSanguineos(dados.data);
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Não há grupos sanguíneos.');
          setShowMessageSnack(true);
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível obter os grupos sanguíneos. Contate o suporte.');
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function carregarFiliacaoStatus() {
    try{
      setLoading(true);
      const params = {
        limit: 100,
      };
      const dados = await api.get('filiacao-status/', {params: params});
      setLoading(false);
      if(dados.data.isSuccess){
        if(dados.data.result.length !== 0){
          setFiliacaoStatus(dados.data);
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Não há status para os filiados');
          setShowMessageSnack(true);
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível obter os status de fiiados. Contate o suporte.');
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function obterDadosVitrineEstatisticaFiliado() {
    try{
      setLoading(true);
      let dados = await dadosVitrineEstatisticaFiliado(filiado);
      if(dados.isSuccess){
        setLoading(false);
        setDadosVitrineEstatistica(dados.result);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function obterDadosEstatisticasPessoais() {
    try{
      setLoading(true);
      let dados = await dadosEstatisticasPessoaisFiliado(filiado);
      if(dados.isSuccess){
        setLoading(false);
        setDadosDetalhadosEstatisticasPessoais(dados.result);

      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function obterDadosEstatisticasTrap() {
    try{
      setLoading(true);
      let dados = await dadosEstatisticasTrapFiliado(filiado);
      if(dados.isSuccess){
        setLoading(false);
        setDadosDetalhadosEstatisticasTrap(dados.result);

      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box
          p={3}
        >
          {children}
        </Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }

  async function saveFiliado() {
    setLoading(true);
    if(edicao){
      try{
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        if(filiado.cpf) {
          filiado.cpf = filiado.cpf.replace('.', "");
          filiado.cpf = filiado.cpf.replace('.', "");
          filiado.cpf = filiado.cpf.replace('-', "");
        }
        const dados = await api.put(`filiados/${filiado.idFiliado}`, filiado);
        if(dados.data.isSuccess){
          setMessageSnack('Usuário atualizado com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          let filiadoRecuperado = await geetFiliadoPorIdFiliado(filiado.idFiliado);
          if (filiadoRecuperado.isSuccess) {
            if (filiadoRecuperado.result.length > 0) {
              filiado = filiadoRecuperado.result[0];
              setFiliado(filiadoRecuperado.result[0]);
              setRefreshState(new Date());
            }
          }
          else {
            history.push('/filiado-list/');
          }
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
        }
        setLoading(false);
      }
      catch (e) {
        setLoading(false);
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    else{
      try{
        setLoading(true);
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        if(filiado.cpf) {
          filiado.cpf = filiado.cpf.replace('.', "");
          filiado.cpf = filiado.cpf.replace('.', "");
          filiado.cpf = filiado.cpf.replace('-', "");
        }
        const dados = await api.post('filiados/', filiado);
        if(dados.data.isSuccess){
          setLoading(false);
          setMessageSnack('Usuário cadastrado com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          let filiadoRecuperado = await geetFiliadoPorIdFiliado(dados.data.result);
          if (filiadoRecuperado.isSuccess) {
            if (filiadoRecuperado.result.length > 0) {
              filiado = filiadoRecuperado.result[0];
              setFiliado(filiadoRecuperado.result[0]);
              edicao = true;
              setEdicao(true);
              loadVisitasFiliados();
              obterDadosVitrineEstatisticaFiliado();
              obterDadosEstatisticasPessoais();
              obterDadosEstatisticasTrap();
              setRefreshState(new Date());
            }
          }
          else {
            history.push('/filiado-list/');
          }
        }
        else{
          setLoading(false);
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
        }
      }
      catch (e) {
        setLoading(false);
        setMessageSnack('Falha de comunicação. Contate o suporte! ERROR: ' + e.toString());
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
  }

  async function downloadPDF() {
    try{
      setLoading(true);
      const params = {
        idFiliado: filiado.idFiliado
      };
      const response = await api.get('relatorio/relatorio-ficha-filiado/',
        {
          params: params,
          responseType: 'blob'
        });
      const file = new Blob(
        [response.data],
        {type: 'application/pdf'});
      setLoading(false);
      const fileURL = window.URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', `proposta_filiacao.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }

  function registrarNovaVisita(event) {
    try {
      event.preventDefault();
      const visitaFiliado = {
        idVisitaFiliado: undefined,
        idFiliado: filiado.idFiliado,
        filiado: filiado,
        dataEntrada: new Date(),
        dataSaida: undefined,
        visitaEncerrada: false,
        valorTotal: 0,
        descontoTotal: 0,
        valorHoraClube: 0
      };
      history.push('/visita-filiado-register-detalhado/', {visitaFiliado: visitaFiliado, edicao: false});
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Ocorreu um erro ao iniciar uma nova visita para esse filiado');
      setShowMessageSnack(true);
    }
  }

  async function aoModificarImagemFiliado(e) {
    try {
      if (e.target.files.length > 0) {
        setLoading(true);
        let novaImagem = e.target.files[0];
        const uploado_image = await uploadImagem(novaImagem);
        if (uploado_image.isSuccess) {
          setLoading(false);
          setMessageSnack('Imagem modificada com sucesso.');
          setTypeSnack('success');
          setShowMessageSnack(true);
          filiado.imagem = uploado_image.result;
          filiado.idImagem = uploado_image.result.idImagem;
          setFiliado(filiado);
        }
        else {
          setLoading(false);
          setMessageSnack(uploado_image.message);
          setTypeSnack('warning');
          setShowMessageSnack(true);
        }
      }
    } catch (e) {
      setLoading(false);
      setMessageSnack('Ocorreu um erro no processamento da requisição.');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }

  }

  async function deletarImagem(e) {
    try {
      e.preventDefault();
      setLoading(true);
      let deleteImagem = await apagarImagem(filiado.idImagem);
      if (deleteImagem.isSuccess) {
        setLoading(false);
        setMessageSnack('Imagem removida com sucesso.');
        setTypeSnack('success');
        setShowMessageSnack(true);
        filiado.imagem = null;
        filiado.idImagem = null;
        setFiliado(filiado);
      }
      else {
        setLoading(false);
        setMessageSnack('Ocorreu um erro no processamento da requisição.');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setMessageSnack('Ocorreu um erro no processamento da requisição.');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  return (
    <Grid
      container
      spacing={1}
    >
      <DialogImpressaoVisitas
        idFiliado={filiado.idFiliado}
        open={abrirDialogImpressaoVisitas}
        setOpen={setAbrirDialogImpressaoVisitas}
      />
      {
        edicao && value === 3 && filiado.visitas.length > 0 &&
        <Grid
          item
          md={12}
          xs={12}
          className={classes.divFab}
        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant="extended"
            onClick={e => setAbrirDialogImpressaoVisitas(true)}
          >
            <PrintIcon
              style={{
                marginRight: 15
              }}
            />
            impressão
          </Fab>
        </Grid>
      }
      <Grid
        item
        md={12}
        xs={12}
      >
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <ValidatorForm
          autoComplete="off"
          onSubmit={saveFiliado}
        >
          <Grid
            container
            spacing={1}
          >
            <Grid
              item
              md={12}
              xs={12}
              style={{
                margin: 10
              }}
            >
              <FiliadoToolbar
                downloadPDF = {downloadPDF}
                saveFiliado={saveFiliado}
                edicao={edicao}
                history={history}
                registrarNovaVisita={registrarNovaVisita}
                filiado={filiado}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <Paper
                className={classes.root}
                elevation={3}
              >
                <AppBar
                  position="static"
                  color="inherit"
                  style={{
                    borderRadius: 35
                  }}
                >

                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    <Tab label="Informações Gerais" icon={<InfoIcon />} {...a11yProps(0)} />
                    <Tab label="Contatos" icon={<ContactPhoneIcon />} {...a11yProps(1)} />
                    <Tab label="Observações" icon={<AssignmentLateIcon />} {...a11yProps(2)} />
                    {edicao && <Tab label="Visitas" icon={<EventAvailableIcon />} {...a11yProps(3)} /> }
                    {edicao && <Tab label="Estatísticas" icon={<BarChartIcon />} {...a11yProps(4)} />  }
                  </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                  <FiliadoRegisterInfo
                    filiado={filiado}
                    setFiliado={setFiliado}
                    filiacaoStatus={filiacaoStatus}
                    edicao={edicao}
                    gruposSanguineos={gruposSanguineos}
                    aoModificarImagemFiliado={aoModificarImagemFiliado}
                    deletarImagem={deletarImagem}
                  />
                </TabPanel>
                <TabPanel
                  value={value}
                  index={1}
                >
                  <FiliadoRegisterContacts
                    filiado={filiado}
                    setFiliado={setFiliado}
                    edicao={edicao}
                  />
                </TabPanel>
                <TabPanel
                  value={value}
                  index={2}
                >
                  <FiliadoRegisterObservacoes
                    filiado={filiado}
                    setFiliado={setFiliado}
                    edicao={edicao}
                    setShowMessageSnack={setShowMessageSnack}
                    setMessageSnack={setMessageSnack}
                    setTypeSnack={setTypeSnack}
                  />
                </TabPanel>
                {edicao &&
                <TabPanel value={value} index={3}>
                  <FiliadoRegisterVisitas
                    filiado={filiado}
                    setFiliado={setFiliado}
                    showMessageSnack={showMessageSnack}
                    setShowMessageSnack={setShowMessageSnack}
                    messageSnack={messageSnack}
                    setMessageSnack={setMessageSnack}
                    typeSnack={typeSnack}
                    setTypeSnack={setTypeSnack}
                    edicao={edicao}
                    history={history}
                    setLoading={setLoading}
                  />
                </TabPanel>
                }
                {edicao &&
                <TabPanel value={value} index={4}>
                  <FiliadoRegisterEstatisticas
                    filiado={filiado}
                    setFiliado={setFiliado}
                    showMessageSnack={showMessageSnack}
                    setShowMessageSnack={setShowMessageSnack}
                    messageSnack={messageSnack}
                    setMessageSnack={setMessageSnack}
                    typeSnack={typeSnack}
                    setTypeSnack={setTypeSnack}
                    edicao={edicao}
                    history={history}
                    setLoading={setLoading}
                    dadosVitrineEstatistica={dadosVitrineEstatistica}
                    dadosDetalhadosEstatisticasPessoas={dadosDetalhadosEstatisticasPessoas}
                    dadosDetalhadosEstatisticasTrap={dadosDetalhadosEstatisticasTrap}
                  />
                </TabPanel>
                }
              </Paper>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Grid>
    </Grid>

  );
}

export default FiliadoRegister;
